import EventBookingsContainer from "../../container/admin/event-bookings";

const EventBookings = () => {
    return <EventBookingsContainer />;
};

export default EventBookings;
